import React from "react"

const SectionWrapper = ({children, id, bgColor, padding}) => (
    <div id={id} className={`${bgColor} ${padding || `px-6 md:px-8 lg:px-16 py-6`} container mx-auto`}>
        {children}
    </div>
)

export default SectionWrapper